module.exports = __webpack_public_path__ + "img/kkb_pro3000.c2eae20b.jpg";